import React from "react";
import { FaComments } from "react-icons/fa";

function ChatHistory({ chats, selectedChatId, setSelectedChatId }) {
  // Sort chats by created_at in descending order (newest first)
  const sortedChats = [...chats].sort((a, b) => {
    return new Date(b.created_at) - new Date(a.created_at);
  });
  
  // Format date function
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };
  
  return (
    <div className="chat-list">
      {sortedChats.length === 0 ? (
        <div className="no-chats-message">
          No chats yet. Start a new conversation!
        </div>
      ) : (
        sortedChats.map((chat) => (
          <div
            key={chat.id}
            className={`chat-session ${selectedChatId === chat.id ? "active" : ""}`}
            onClick={() => setSelectedChatId(chat.id)}
          >
            <FaComments style={{ marginRight: '8px' }} />
            <span title={`Created: ${formatDate(chat.created_at)}`}>
              {chat.name || `Chat - ${formatDate(chat.created_at)}`}
            </span>
          </div>
        ))
      )}
    </div>
  );
}

export default ChatHistory;